<template>
  <el-dialog title="设置备注" v-model="visible" width="1240px">
    <el-form ref="ruleForm" :model="addRow" label-width="100px">
      <form-item-rule label="备注" prop="isVip">
        <el-input v-model="addRow.remark" type="textarea" :rows="5"></el-input>
      </form-item-rule>
    </el-form>
    <template #footer>
          <span class="dialog-footer">
            <el-button @click="visible = false">取 消</el-button>
            <el-button type="primary" @click="doSave()">确 定</el-button>
          </span>
    </template>
  </el-dialog>
</template>

<script>
import QcContainer from "/src/components/el/layout/qc-container.vue";
import FormItemRule from "@/components/el/form-item-rule.vue";

export default {
  name: "set-remark",
  components: {FormItemRule, QcContainer},
  data() {
    return {
      visible:false,
      addRow:{id:"",remark:""}
    }
  },
  mixins: [tableBase],
  methods: {
    open(id,remark){
      this.addRow = {id:id,remark:remark||""};
      this.visible = true;
    },
    doSave(){
      this.$refs['ruleForm'].validate((valid) => {
        if (valid) {
          this.simplePost("/api/mgr/business/shop/customer/setRemark",this.addRow,res=>{
            this.$emit('load');
            this.visible = false;
          })
        }
      });
    }
  },
  mounted() {

  }
}
</script>


<style lang="less" scoped>
</style>
